import { Component, Label, _decorator } from 'cc';
import Dropdown from '../../../../common/scripts/Toolkit/Components/Dropdown/Dropdown';
import LocalizedLabel from '../../../../common/scripts/Toolkit/Components/LocalizedComponent/LocalizedLabel';
import SlotGameText from '../../Data/Config/SlotGameTextSet';

export enum BGMOption {
    Random,
    First,
    Second,
}

const { ccclass, requireComponent } = _decorator;
const bgmDisplayOrder: BGMOption[] = [BGMOption.Random, BGMOption.First, BGMOption.Second];
const bgmDisplayKeyMap: { [value in BGMOption]?: string } = {
    [BGMOption.Random]: SlotGameText.RANDOM,
    [BGMOption.First]: 'BGM 1',
    [BGMOption.Second]: 'BGM 2',
};

@ccclass('BGMDropdown')
@requireComponent(Dropdown)
export default class BGMDropdown extends Component {
    private _dropdown: Dropdown<BGMOption> = null;

    private get dropdown() {
        if (!this._dropdown) {
            this._dropdown = this.getComponent(Dropdown) as Dropdown<BGMOption>;
        }
        return this._dropdown;
    }

    protected onLoad() {
        this.dropdown.init(
            bgmDisplayOrder,
            (displayName, selectedOption) => {
                const localizedLabel = displayName.getComponent(LocalizedLabel);
                if (selectedOption === BGMOption.Random) {
                    localizedLabel.enabled = true;
                    displayName.getComponent(LocalizedLabel).key = bgmDisplayKeyMap[selectedOption];
                } else {
                    localizedLabel.enabled = false;
                    displayName.getComponent(Label).string = bgmDisplayKeyMap[selectedOption];
                }
            },
            (node, option) => {
                const localizedLabel = node.getComponentInChildren(LocalizedLabel);
                if (option === BGMOption.Random) {
                    localizedLabel.enabled = true;
                    node.getComponentInChildren(LocalizedLabel).key = bgmDisplayKeyMap[option];
                } else {
                    localizedLabel.enabled = false;
                    node.getComponentInChildren(Label).string = bgmDisplayKeyMap[option];
                }
            },
        );
    }
}
